export enum ExtendedKeyUsages {
  csn369791TlsClient = '1.2.203.7064.1.1.369791.1',
  csn369791TlsServer = '1.2.203.7064.1.1.369791.2',
  clientAuthentication = '1.3.6.1.5.5.7.3.2',
  codeSigning = '1.3.6.1.5.5.7.3.3',
  eapOverLan = '1.3.6.1.5.5.7.3.14',
  eapOverPpp = '1.3.6.1.5.5.7.3.13',
  etsiTslSigning = '0.4.0.2231.3.0',
  emailProtection = '1.3.6.1.5.5.7.3.4',
  icaoDeviationListSigning = '2.23.136.1.1.8',
  icaoMasterListSigning = '2.23.136.1.1.3',
  intelAmtManagement = '2.16.840.1.113741.1.2.3',
  internetKeyExchangeForIpsec = '1.3.6.1.5.5.7.3.17',
  kerberosClientAuthentication = '1.3.6.1.5.2.3.4',
  kerberosKdc = '1.3.6.1.5.2.3.5',
  msCommercialCodeSigning = '1.3.6.1.4.1.311.2.1.22',
  msDocumentSigning = '1.3.6.1.4.1.311.10.3.12',
  msEfsRecovery = '1.3.6.1.4.1.311.10.3.4.1',
  msEncryptedFileSystem = '1.3.6.1.4.1.311.10.3.4',
  msIndividualCodeSigning = '1.3.6.1.4.1.311.2.1.21',
  msSmartCardLogon = '1.3.6.1.4.1.311.20.2.2',
  ocspSigner = '1.3.6.1.5.5.7.3.9',
  pdfSigning = '1.2.840.113583.1.1.5',
  pivCardAuthentication = '2.16.840.1.101.3.6.8',
  scvpClient = '1.3.6.1.5.5.7.3.16',
  scvpServer = '1.3.6.1.5.5.7.3.15',
  sipDomain = '1.3.6.1.5.5.7.3.20',
  sshClient = '1.3.6.1.5.5.7.3.21',
  sshServer = '1.3.6.1.5.5.7.3.22',
  serverAuthentication = '1.3.6.1.5.5.7.3.1',
  timeStamping = '1.3.6.1.5.5.7.3.8',
}
